import { MultiValuesNode, SingleValueNode } from '../../types/chartDataTypes';
import {
  asSingleValueNodes,
  getValue,
  mapNode,
  withGroupInfo,
  withoutLeafNodes,
} from '../../shared/helper/chartDataHelper';

export type IncomeStatementChartData = {
  pieData: MultiValuesNode,
  tableData: MultiValuesNode,
  tableHeadline: string,
};

export type IncomeStatementData = {
  charts: IncomeStatementChartData[],
  allTableData: MultiValuesNode,
};

export const prepareData = (
  data: MultiValuesNode,
  notesLabel: string,
  dataLabel: string,
): IncomeStatementData => {
  const multiValuesData = mapNode(data, (src, target: MultiValuesNode) => {
    target.values = {
      ...src.values,
      [notesLabel]: (src as any).note,
    };
  });
  const dataWithGroupInfo = withGroupInfo(multiValuesData);

  const allTableData = withoutLeafNodes({
    entries: multiValuesData.entries,
    totalLabel: multiValuesData.totalLabel,
    values: dataWithGroupInfo.values,
  } as MultiValuesNode);

  const chartData = dataWithGroupInfo.entries.map((entry, index) => {
    let value = getValue(entry, dataLabel);
    if (value == null) {
      value = entry.entries.reduce((result, childEntry) => (
        result + (getValue(childEntry, dataLabel) || 0)
      ), 0);
    }
    const pieData: SingleValueNode = {
      value,
      // we remove the first groups here
      entries: entry.entries.reduce((result, mainEntry) => (
        result.concat(asSingleValueNodes(mainEntry.entries, dataLabel))
      ), [] as SingleValueNode[]),
    };

    const tableData: MultiValuesNode = {
      entries: [{
        // the name is used as headline, so we skip it here
        entries: allTableData.entries[index].entries,
        values: allTableData.entries[index].values,
        totalLabel: allTableData.entries[index].totalLabel,
      }],
      totalLabel: allTableData.totalLabel,
      values: allTableData.values,
    };

    // only keep the total values for the last entry...
    if (index < dataWithGroupInfo.entries.length - 1) {
      tableData.values = {};
      tableData.totalLabel = undefined;
    }

    return {
      pieData,
      tableData,
      tableHeadline: entry.name,
    };
  });

  return {
    charts: chartData,
    allTableData,
  };
};
